<template>
  <div>
    <div class="card is-min-width-700">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">{{ $t('detail.remiseBancaireReglement.title')}}</h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="messages"
                            :error="error"
                            :messagesChampsVide="messagesChampsVide"
                            :champsVide="champsVide"
                            :title="'editionClient.problemOccurred'"
                            :withEmplyFields="true"
                            @close="error = $event"/>
        <avertissement-msg-component :title="'general.warning'"
                            :avertissement="avertissement"
                            :canClose="false"
                            :messages="[{ message:
                              'detail.remiseBancaireReglement.warning.domiciliationBancaire'
                              }]">
        </avertissement-msg-component>
        <div class="columns mgt-20px">
          <b-field :label="$t('detail.remiseBancaireReglement.modeReglement')"
                   class="obligatoire column is-6">
            <b-select v-model="remiseBancaire.modeReglementId" expanded>
              <option v-for="reglement in modeReglement"
                      :value="reglement.id" :key="reglement.id">
                {{ reglement.libelle }}
              </option>
            </b-select>
          </b-field>
          <b-field :label="$t('detail.remiseBancaireReglement.banque')"
                   class="obligatoire column is-6">
            <b-select v-model="remiseBancaire.domiciliationBancaireId" expanded>
              <option v-for="domiciliation in filterDomiciliationBancaire"
                      :value="domiciliation.id" :key="domiciliation.id">
                {{ `${domiciliation.libelle} ${domiciliation.libelleBanque ?
                `- ${domiciliation.libelleBanque}` : ''}` }}

              </option>
            </b-select>
          </b-field>
        </div>
        <div class="columns">
          <b-field :label="$t('detail.remiseBancaireReglement.nomTire')"
                   class="column is-6">
            <b-input v-model="reglement.emetteur"></b-input>
          </b-field>
          <b-field :label="$t('detail.remiseBancaireReglement.referenceTire')"
                   class="column is-6">
            <b-input v-model="reglement.referenceReglement"></b-input>
          </b-field>
        </div>
        <b-field class="mgt-20px">
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="sendEvent">
              {{ $t('detail.buttons.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="payFacture">
              {{ $t('detail.buttons.payer') }}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatIsoDate';
import translate from '@/services/remiseBancaire/validation/champsRemiseBancaireTranslator';
import validation from '@/services/remiseBancaire/validation/validationRemiseBancaire';
import validationGeneral from '@/services/validation/validation';
import messageErreur from '@/services/general/messageErreur';
import { create, update } from '@/api/remiseBancaire/index';
import genererReglement from '@/services/reglement/genererReglement';
import genererRemiseBancaire from '@/services/remiseBancaire/genererRemiseBancaire';
import { create as createReglement } from '@/api/reglement/index';
import { sauvegarde } from '@/api/lettrage/index';
import messageSucces from '@/services/general/messageSucces';
import { VALIDE } from '@/configuration/remiseBancaire/remiseBancaireConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import avertissementMsgComponent from '@/components/general/avertissementMsgComponent';

const Parametres = createNamespacedHelpers('parametres');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'popUpRemiseBancaireReglement',
  props: {
    detailDevisCommande: {
      required: true,
      type: Object,
    },
    isFactureNormal: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  components: {
    errorMsgComponent,
    avertissementMsgComponent,
  },
  data() {
    return {
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      domiciliationBancaire: [],
      modeReglement: [],
      reglement: genererReglement(),
      remiseBancaire: genererRemiseBancaire(),
      avertissement: false,
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    async createRemiseBancaire() {
      this.remiseBancaire.dateRemise = formatDate(this.remiseBancaire.dateRemise);
      this.remiseBancaire.societeId = this.societeActiveId;
      const remiseBancaireInformation = (await create(this.remiseBancaire)).data.result;
      return remiseBancaireInformation;
    },
    async createReglementOfEachEcheance(remiseBancaireId) {
      const reglementsPromises = [];
      this.detailDevisCommande.echeancierPaiement.forEach((echeancier) => {
        const newReglement = {
          remiseBancaireId: remiseBancaireId,
          dateReglement: formatDate(new Date(
            echeancier.dateEcheance,
          )),
          emetteur: this.reglement.emetteur,
          referenceReglement: this.reglement.referenceReglement,
          montantTtc: echeancier.montant,
          tiersId: this.detailDevisCommande.destinataireComptable.tiersId,
        };
        reglementsPromises.push(createReglement(newReglement));
      });
      const reglements = await Promise.all(reglementsPromises);
      return reglements;
    },
    async sauvegardeLettrageOfEachEcheance(reglementsOfEachEcheance) {
      const lettrages = {
        lettrages: [],
      };
      for (let count = 0; count < this.detailDevisCommande.echeancierPaiement.length; count += 1) {
        const reglementAssocie = reglementsOfEachEcheance[count].data.result;
        const newLettrage = {
          id: undefined,
          dateLettrage: formatDate(new Date()),
          montant: reglementAssocie.montantTtc,
          mouvementClient1Id: this.detailDevisCommande.echeancierPaiement[count].id,
          mouvementClient2Id: reglementAssocie.id,
        };
        lettrages.lettrages.push(newLettrage);
      }
      await sauvegarde(lettrages);
    },
    async payFacture() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const remiseBancaireInformation = await this.createRemiseBancaire();
        const reglementsOfEachEcheance = await this.createReglementOfEachEcheance(
          remiseBancaireInformation.id,
        );
        await this.sauvegardeLettrageOfEachEcheance(reglementsOfEachEcheance);
        remiseBancaireInformation.etat = VALIDE;
        await update(remiseBancaireInformation);
        this.sendEvent();
        messageSucces(this.$i18n.t('detail.remiseBancaireReglement.facturePayer'));
        this.$router.go(0);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = validation(e.response, this.remiseBancaire.sens);
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        } messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    sendEvent() {
      this.$emit('close', true);
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    filterDomiciliationBancaire() {
      return this.isFactureNormal ? this.domiciliationBancaire
        .filter((domicilisation) => {
          return !domicilisation.interfaceComptable && domicilisation.actif;
        }) : this.domiciliationBancaire.filter((domicilisation) => {
        return domicilisation.actif;
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.isFactureNormal) {
        this.remiseBancaire.modeReglementId = this.detailDevisCommande.modeReglementId;
      }
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
        typesParametres.PARAMETRES_KEYS.modeReglement,
      ]);
      this.modeReglement = this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
      this.domiciliationBancaire = this.parametre(
        typesParametres.PARAMETRES_KEYS.domiciliationBancaire,
      );
      this.avertissement = this.filterDomiciliationBancaire.length === 0;

      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
